import type { ReflectionSummary } from '../types';

interface ReflectionListProps {
  reflections: ReflectionSummary[];
  selectedWeek: string | null;
  onSelect: (week: string) => void;
}

export function ReflectionList({ reflections, selectedWeek, onSelect }: ReflectionListProps) {
  if (reflections.length === 0) {
    return <p className="text-sm text-ink-tertiary">No reflections generated yet.</p>;
  }

  return (
    <div className="space-y-2">
      {reflections.map((item) => (
        <button
          key={item.week}
          onClick={() => onSelect(item.week)}
          className={`w-full text-left p-3 rounded-xl border transition-colors ${
            selectedWeek === item.week ? 'border-accent bg-accent-bg' : 'border-edge bg-white hover:bg-canvas'
          }`}
        >
          <p className="text-sm font-semibold text-ink">Week {item.week}</p>
          <p className="text-xs text-ink-secondary mt-1">
            {new Date(item.generated_at).toLocaleString()}
          </p>
          {item.highlights[0] && (
            <p className="text-sm text-ink-secondary mt-2 line-clamp-2">{item.highlights[0]}</p>
          )}
        </button>
      ))}
    </div>
  );
}

export default ReflectionList;
